import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * Frontpage Widget
 */
@Component({
  selector: 'frontpage-widget',
  templateUrl: './frontpage-widget.component.html',
  styleUrls: ['../../common/css/general.scss','./frontpage-widget.component.scss']
})
export class FrontpageWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'frontpage', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("frontpage", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('frontpage').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('frontpage', this.getReport()).pipe();
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {   
    this.setDirtyFlag(false);
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }
}
